import type { PublicApiKey } from '#packages/apilib';
import type { createPagesApi } from './pagesWrapper';

export const PagesApiKey: PublicApiKey<typeof createPagesApi> = {
  name: 'PagesApi',
  public: true,
};
